import React, { Component } from 'react';
import { Link, Redirect, RouteProps } from 'react-router-dom';
import { Container, Dimmer, Form, Loader } from 'semantic-ui-react';
import { CompanyModel } from '../../entities/company.model';
import './store-client-company.scss';

interface StoreClientCompanyProps extends RouteProps {
  match: any;
  history: any;
}

interface StoreClientCompanyState {
  model: CompanyModel;
  loading: boolean;
  errorMsg: string;
  successMsg: string;
  redirect: string;
}

class StoreClientCompany extends Component<StoreClientCompanyProps, StoreClientCompanyState> {
  constructor(props: any) {
    super(props);
    this.state = {
      model: new CompanyModel(),
      loading: false,
      errorMsg: '',
      successMsg: '',
      redirect: ''
    };

    this.onNameChange = this.onNameChange.bind(this);
    this.onRegisterChange = this.onRegisterChange.bind(this);
    this.onPhoneChange = this.onPhoneChange.bind(this);
    this.onTownChange = this.onTownChange.bind(this);
    this.onDistrictChange = this.onDistrictChange.bind(this);
    this.onAddressUnitChange = this.onAddressUnitChange.bind(this);
    this.onStreetChange = this.onStreetChange.bind(this);
    this.save = this.save.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onNameChange(e: any) {
    let model = { ...this.state.model };
    model.name = e.target.value;
    this.setState({ model });
  }

  onRegisterChange(e: any) {
    let model = { ...this.state.model };
    model.register = e.target.value;
    this.setState({ model });
  }

  onPhoneChange(e: any) {
    let model = { ...this.state.model };
    model.phone = e.target.value;
    this.setState({ model });
  }

  onTownChange(e: any) {
    let model = { ...this.state.model };
    model.town = e.target.value;
    this.setState({ model });
  }

  onDistrictChange(e: any) {
    let model = { ...this.state.model };
    model.district = e.target.value;
    this.setState({ model });
  }

  onAddressUnitChange(e: any) {
    let model = { ...this.state.model };
    model.unit = e.target.value;
    this.setState({ model });
  }

  onStreetChange(e: any) {
    let model = { ...this.state.model };
    model.street = e.target.value;
    this.setState({ model });
  }

  validate(): boolean {
    this.setState({ successMsg: '' });
    if (!this.state.model.name) {
      this.setState({ errorMsg: 'Байгууллагын нэрийг оруулна уу.' });
      return false;
    }
    if (!this.state.model.register) {
      this.setState({ errorMsg: 'Байгууллагын регистр оруулна уу.' });
      return false;
    }
    if (!this.state.model.phone) {
      this.setState({ errorMsg: 'Утасны дугаар оруулна уу.' });
      return false;
    }
    if (!this.state.model.town) {
      this.setState({ errorMsg: 'Хот оруулна уу' });
      return false;
    }
    if (!this.state.model.street) {
      this.setState({ errorMsg: 'Дэлгэрэнгүй хаяг оруулна уу' });
      return false;
    }
    this.setState({ errorMsg: '' });
    return true;
  }

  async save() {
    if (!this.validate()) {
      window.scrollTo(0, 0);
      return;
    }

    const token = localStorage.getItem('clientToken');
    if (!token || token === 'undefined') {
      this.setState({ errorMsg: 'Нэвтэрнэ үү' });
      window.scrollTo(0, 0);
      return;
    }

    this.setState({ loading: true, errorMsg: '' });

    const payload = {
      name: this.state.model.name,
      register: this.state.model.register,
      phone: this.state.model.phone,
      town: this.state.model.town,
      district: this.state.model.district,
      unit: this.state.model.unit,
      street: this.state.model.street
    };

    try {
      const res = await fetch(process.env.REACT_APP_API_URL + 'client/company/new', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (res.status === 200) {
        this.setState({
          loading: false,
          successMsg: 'Амжилттай хадгаллаа.',
          errorMsg: '',
          model: new CompanyModel()
        });
        window.scrollTo(0, 0);
        setTimeout(() => {
          this.props.history.push('/store');
        }, 2000);
      } else if (res.status === 401) {
        this.setState({
          loading: false,
          errorMsg: 'Нэвтэрнэ үү',
          redirect: '/login'
        });
        window.scrollTo(0, 0);
      } else {
        const resJson = await res.json();
        this.setState({
          loading: false,
          errorMsg: resJson.error || resJson.errorMsg || 'Хадгалахад алдаа гарлаа'
        });
        window.scrollTo(0, 0);
      }
    } catch (err) {
      this.setState({
        loading: false,
        errorMsg: 'Сүлжээний алдаа'
      });
      console.error(err);
      window.scrollTo(0, 0);
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    return (
      <div className="page store-client-company-page">
        <Container>
          <Dimmer active={this.state.loading} inverted>
            <Loader size="medium"></Loader>
          </Dimmer>
          <div className="store-menu">
            <Link to="/store" className="menu-item ui button">
              Дэлгүүр
            </Link>
          </div>
          <div className="full-width text-center">
            <h1>Шинэ байгууллага</h1>
          </div>
          <div className="store-client-company-form">
            <Form widths="equal">
              <Form.Group>
                {this.state.successMsg ? (
                  <div className="success-msg">{this.state.successMsg}</div>
                ) : null}
                {this.state.errorMsg ? (
                  <div className="error-msg">{this.state.errorMsg}</div>
                ) : null}
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  label="Байгууллагын нэр"
                  required
                  control="input"
                  value={this.state.model.name}
                  onChange={this.onNameChange}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  label="Байгууллагын регистр"
                  required
                  control="input"
                  value={this.state.model.register}
                  onChange={this.onRegisterChange}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field
                  label="Утасны дугаар"
                  required
                  control="input"
                  value={this.state.model.phone}
                  onChange={this.onPhoneChange}
                />
              </Form.Group>
              <Form.Group>
                <div style={{ height: '35px' }}>
                  <strong>Хаяг:</strong>
                </div>
              </Form.Group>
              <Form.Group>
                <Form.Input
                  label="Хот"
                  required
                  value={this.state.model.town}
                  onChange={this.onTownChange}
                />
              </Form.Group>
              <Form.Group>
                <Form.Input
                  label="Дүүрэг"
                  value={this.state.model.district}
                  onChange={this.onDistrictChange}
                />
              </Form.Group>
              <Form.Group>
                <Form.Input
                  label="Хороо"
                  value={this.state.model.unit}
                  onChange={this.onAddressUnitChange}
                />
              </Form.Group>
              <Form.Group>
                <Form.TextArea
                  label="Дэлгэрэнгүй хаяг"
                  required
                  value={this.state.model.street}
                  onChange={this.onStreetChange}
                />
              </Form.Group>
              <br />
              <Form.Button
                disabled={this.state.loading}
                onClick={() => this.save()}
                color="red"
              >
                Хадгалах
              </Form.Button>
            </Form>
          </div>
        </Container>
      </div>
    );
  }
}

export default StoreClientCompany;

